module.exports = __webpack_public_path__ + "img/15.62cce105.png";